<template>
    <div
        class="title font22 underline"
    >
        <ul class="mb-0 mx-auto d-flex justify-content-center">
            <li
                v-for="(item, index) in titleName"
                :key="item.name"
                class="tab-item"
                :class="{'active': activeTab===index }"
                @click="$emit('changeActive', index )"
            >{{ item.name }}</li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'Theme',
    props: {
        underline: {
            type: Boolean,
            default: true,
        },
        activeTab: {
            type: Number,
            require: true,
        },
        titleName: {
            type: Array,
            require: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.title {
    // margin-bottom: 0.5rem;
    @include media-breakpoint-up(md) {
        margin-bottom: 1.25rem;
    }
    &.underline {
        border-bottom: 1px solid $gray-300;
        .tab-item {
            padding-bottom: 0.5rem;
            border-bottom: 2px solid $white;
            display: inline-block;
            padding: 0 8px;
            cursor: pointer;
        }
        .tab-item.active {
            border-bottom: 2px solid $primary;
            font-weight: bold;
            cursor: initial
        }
    }
    &.font22 {
        font-size: 1.375rem;
        line-height: 2;
    }
}
</style>
